import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyAywNEesWtO-VZyzN1II495GhmRwcrf2ew',
  authDomain: 'pregunta-importante.firebaseapp.com',
  databaseURL: 'https://pregunta-importante.firebaseio.com',
  projectId: 'pregunta-importante',
  storageBucket: 'pregunta-importante.appspot.com',
  messagingSenderId: '28227172723',
  appId: '1:28227172723:web:252e9d2f0e570d61e62d06',
  measurementId: 'G-Q1965QV079',
};

export default firebase.initializeApp(firebaseConfig);
